import * as Sentry from "@sentry/react";
import { isDevelopment, ENV_STAGE } from "../config";

Sentry.init({
  dsn: "https://344c62e5eb4df965b902e4db04850f53@o4509842484363264.ingest.de.sentry.io/4509865414623312",
  integrations: [Sentry.browserTracingIntegration()],
  environment: ENV_STAGE,
  enabled: !isDevelopment(),

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [/^https:\/\/e-oasis-api\.de-c1\.cloudhub\.io\//],
});
